import React, { Component } from 'react';
import {message, Select} from "antd";
import {FilterOutlined} from '@ant-design/icons';
import {orderBy, cloneDeep} from "lodash";

import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import Loader from "../../../Common/Component/Loader";
import Customer from "./Customer";
import Proposal from "./Proposal";
import Kanban from "./Kanban/Kanban";
import {errorHandle} from "../../../Common/errorHandle";

const {Option} = Select;
let prevSelectedTab = 0;

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myId: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid,
      errors: {},
      franchiseList: {},
      currentTab: prevSelectedTab,
      filterData: {
        franchise: 'all',
        active: false,
        inactive: false,
        filterFranchise: '',
        joined: [],
        lastService: [],
        outstanding: [],
        satisfaction: ''
      },
      search_value: '',
      showAddProposal: false,
      showCustomerDrawer: false
    }
  }

  componentDidMount = () => {
    this.props.getFranchise(); // get franchise list
    // get logged in user roles
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    this.setState({logged_in_user_role})
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // errors
    if (Object.keys(nextProps?.Settings?.errors).length > 0 && nextProps?.Settings?.errors !== this.props?.Settings?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.Settings?.errors)
    }

    if (Object.keys(nextProps?.CommercialProposal?.errors).length > 0 && nextProps?.CommercialProposal?.errors !== this.props?.CommercialProposal?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CommercialProposal?.errors)
    }

    if (Object.keys(nextProps?.CommercialCustomer?.errors).length > 0 && nextProps?.CommercialCustomer?.errors !== this.props?.CommercialCustomer?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CommercialCustomer?.errors)
    }
    //////////////////////////////////////////////////////////

    // get franchise list
    if (Object.keys(nextProps?.Settings?.franchise).length > 0 && JSON.stringify(nextProps?.Settings?.franchise) !== JSON.stringify(this.prop?.Settings?.franchise)) {
      this.setState({franchiseList: nextProps?.Settings?.franchise});
    }
    this.setState({loader: false});
  }

  // get logged in user
  getLoggedInUserRole = () => {
    const {logged_in_user_role} = this.state;

    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_franchise = logged_in_user_role?.includes('accounting_franchiese')
    const is_ope_mgr_franchise = logged_in_user_role?.includes('operations_mgr')
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);
    return {is_franchise_owner, franchise_uuid: franchise_uuid?.join(', '), is_disable_franchise_dropdown: (is_ope_mgr_franchise || is_account_franchise || is_buss_dev_franchise)}
  }

  // on filter change
  onFilterChange = (e, type) => {
    const {filterData} = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(filterData, {[e.target.name]: value});
    this.setState({filterData: {...filterData}});
  }

  // on switch tab
  switchTab = (value) => {
    prevSelectedTab = value
    const {filterData} = this.state;
    Object.assign(filterData, {franchise: 'all'})
    this.setState({currentTab: value})
    if (value === 2) this.setState({search_value: ''})
  };
  
  // add zero before number
  leadingZeros = (value, size) => {
    let s = String(value);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  toggleAddProposal = (value) => {
    this.setState({showAddProposal: value})
  }

  toggleLoader = (value) => {
    this.setState({loader: value})
  }

  onSearch = (e) => {
    const value = e.target.value;

    if (value !== this.state.search_value) {
      this.setState({search_value: value});
    }
  }

  // toggle customer filter drawer
  toggleCustomerDrawer = (val) => {
    this.setState({showCustomerDrawer: val})
  }

  //clear filter
  onClearCustomerFilter = () => {
    this.setState({
      filterData: {
        active: false,
        inactive: false,
        franchise: 'all',
        joined: [],
        lastService: [],
        outstanding: [],
        satisfaction: ''
      }
    });
  };

  renderTab = () => {
    const {currentTab, filterData, search_value, showCustomerDrawer} = this.state;
    switch (currentTab) {
    case 0:
      return <Customer
        history={this.props.history}
        toggleLoader={this.toggleLoader}
        filterData={cloneDeep(filterData)}
        onFilterChange={this.onFilterChange}
        search_value={search_value}
        showCustomerDrawer={showCustomerDrawer}
        toggleCustomerDrawer={this.toggleCustomerDrawer}
        onClearCustomerFilter={this.onClearCustomerFilter}

        //APIs
        getCommercialCustomerList={this.props.getCommercialCustomerList}
        deleteCommercialCustomer={this.props.deleteCommercialCustomer}
        getResourceList={this.props.getResourceList}
        addResource={this.props.addResource}
        updateResource={this.props.updateResource}
        deleteResource={this.props.deleteResource}

        // Reducers
        CommercialCustomer={this.props.CommercialCustomer}
        Settings={this.props.Settings}
        Resource={this.props.Resource}
      />
    case 1:
      return <Proposal
        history={this.props.history}
        toggleLoader={this.toggleLoader}
        search_value={search_value}
        filterData={cloneDeep(filterData)}
        onFilterChange={this.onFilterChange}

        // APIs
        getAllQuote={this.props.getAllQuote}

        // Reducers
        CommercialProposal={this.props.CommercialProposal}
      />
    case 2:
      return <Kanban
        history={this.props.history}
        filterData={cloneDeep(filterData)}
        // APIs
        getCommercialProposal={this.props.getCommercialProposal}
        addPWSInstall={this.props.addPWSInstall}
        updatePWSInstall={this.props.updatePWSInstall}
        //Reducers
        CommercialProposal={this.props.CommercialProposal}
        CommercialKanban={this.props.CommercialKanban}
      />
    default:
      return <Customer
        history={this.props.history}
        toggleLoader={this.toggleLoader}
        filterData={cloneDeep(filterData)}
        onFilterChange={this.onFilterChange}
        search_value={search_value}
        showCustomerDrawer={showCustomerDrawer}
        toggleCustomerDrawer={this.toggleCustomerDrawer}

        //APIs
        getCommercialCustomerList={this.props.getCommercialCustomerList}
        deleteCommercialCustomer={this.props.deleteCommercialCustomer}
        getResourceList={this.props.getResourceList}
        addResource={this.props.addResource}
        updateResource={this.props.updateResource}
        deleteResource={this.props.deleteResource}

        // Reducers
        CommercialCustomer={this.props.CommercialCustomer}
        Settings={this.props.Settings}
        Resource={this.props.Resource}
      />
    }
  }
  
  render() {
    const {
      filterData,
      franchiseList,
      loader,
      search_value,
      currentTab
    } = this.state;
    const {is_disable_franchise_dropdown} = this.getLoggedInUserRole()

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder={(currentTab === 0 || currentTab === 1) ? 'Acc Number, HOA, Community Manager & Phone Number' : 'Search acc number, customer address or contact details'}
            search_value={search_value}
            onSearch={this.onSearch}
            onEnter={(e) => this.setState({search_value: '', loader: true}, () => this.onSearch(e))}
          />

          {/* Sidebar */}
          <Sidebar />

          <div className="container">
            {loader && <Loader/>}
            <div className="filter_wrapper">
              <div className="left_side">
                <div className="fitem">
                  <Select
                    className="swhite"
                    placeholder="Select a Franchise"
                    name="franchise"
                    disabled={is_disable_franchise_dropdown}
                    onChange={(e) => this.onFilterChange({target: {name: 'franchise', value: e}}, '', 'franchise')}
                    value={filterData?.franchise || undefined}>
                    <Option key={'franchiseAll'} value={'all'}>{'All Franchises'}</Option>
                    {
                      orderBy(franchiseList?.results, 'id', 'asc')?.map((option) =>
                        <Option key={option?.uuid} value={option?.uuid}>{`${this.leadingZeros(option?.id, 3)} ${option?.name}`}</Option>)
                    }
                  </Select>
                </div>
                <ul className="tabs">
                  <li className={currentTab === 0 ? 'active' : ''} onClick={() => { this.switchTab(0); }}>
                    <span>CUSTOMERS</span>
                  </li>
                  <li className={currentTab === 1 ? 'active' : ''} onClick={() => { this.switchTab(1); }}>
                    <span>PROPOSAL</span>
                  </li>
                  {/* <li className={currentTab === 2 ? 'active' : ''} onClick={() => { this.switchTab(2); }}>
                    <span>KANBAN</span>
                  </li> */}
                </ul>
              </div>
              <div className="right_side">
                {currentTab !== 2 ? <span className="ico-btn">
                  <FilterOutlined onClick={() => {
                    if (currentTab === 0) {
                      this.setState({showCustomerDrawer: true})
                    }
                  }}>Filter</FilterOutlined>
                </span> : '' }

                {(currentTab === 0 || currentTab === 1) && <button className="btn btn-warning"
                  onClick={() => this.props.history.push('/commercial/new-proposal')}
                >{`Add New Proposal`}</button>}
              </div>
            </div>
            <div className="data">
              {this.renderTab()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;
